export const changeEmailUrl = '/changeEmail';
export interface ChangeEmailType {
  email: string;
}

export const verifyEmailUrl = '/changeEmail/verify';
export interface VerifyEmailType {
  code: string;
  email: string;
  emailHash: string;
}
